export default "__VITE_ASSET__e2cb3358__"